import React from 'react';
import PropTypes from 'prop-types';
import './RadioButton.css';

const RadioButton = ({ label, name, value, checked, onChange }) => {
  return (
    <label className="RadioButton-label">
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        className="RadioButton-input"
      />
      <span className="RadioButton-custom"></span>
      <span className="RadioButton-text">{label}</span>
    </label>
  );
};

RadioButton.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default RadioButton;
